import Vue from 'vue'
import VueRouter from 'vue-router'

const layout = () => import(/* webpackChunkName: "index" */ '@/components/layout/index.vue')

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    component: layout,
    meta: { title: '首页', keepAlive: false },
    children: [{
      path: '/home',
      name: 'center',
      component: () => import(/* webpackChunkName: "index" */ '@/views/Index/index.vue'),
      //component: () => import(/* webpackChunkName: "index" */ '@/views/outer/order/list.vue'),
      meta: { title: '首页', keepAlive: false, hasFooter:true,navigationBarBackgroundColor: '#fe6b0b' }

    }
    ]
  },
  {
    path: '/game',
    name: 'game',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/game/index.vue'),
    meta: { title: '游戏中心', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/game',
    name: 'game',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/game/index.vue'),
    meta: { title: '游戏中心', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/gameDetail',
    name: 'gameDetail',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/gameDetail/index.vue'),
    meta: { title: '游戏中心', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/activity/index.vue'),
    meta: { title: '活动中心', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/activityDetail',
    name: 'activityDetail',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/activityDetail/index.vue'),
    meta: { title: '活动中心', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/news/index.vue'),
    meta: { title: '收费资讯', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/about/index.vue'),
    meta: { title: '关于我们', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/add',
    name: 'add',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/add/index.vue'),
    meta: { title: '加入我们', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/disputeHandling',
    name: 'disputeHandling',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/disputeHandling/index.vue'),
    meta: { title: '纠纷处理', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/guardianshipProject',
    name: 'guardianshipProject',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/guardianshipProject/index.vue'),
    meta: { title: '家长监护', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '/antiAddictionSystem',
    name: 'antiAddictionSystem',
    component: () => import(/* webpackChunkName: "drainage" */ '@/views/antiAddictionSystem/index.vue'),
    meta: { title: '防沉迷系统', keepAlive: false,  hasNoHeader: true , hasFooter:true}
  },
  {
    path: '*',
    name: 'About',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'About',
    component: () => import('../views/404.vue'),
    meta: { title: '闲逸游戏中心', keepAlive: false }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ y: 0 })
})

export default router
